import React, { useEffect } from "react";
import { Button, Form, Input, message, Alert } from "antd";
import { PhoneOutlined, SendOutlined } from "@ant-design/icons";
import axios from "axios";

const ACCENT = "#27b2c4";

const CallBackPage = () => {
  const [form] = Form.useForm();
  const [formSuccessMessage, setFormSuccessMessage] = React.useState("");

  useEffect(() => {
    logUserActivity({ detail: "" });
    document.title = "JOJ | Call Back Request ";
  }, []);

  const logUserActivity = async ({ detail }) => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "6",
        DetailID: "0",
        Detail: detail,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  const handleSubmit = (values) => {
    message.success("Request submitted successfully!");

    try {
      setFormSuccessMessage("");
      const listData = {
        Name: values.name,
        ContactNumber: values.mobile,
      };

      let config = {
        method: "post",

        url: global.config.APIURL.BaseURL + "api/CallBackRequest/InsertRequest",
        headers: {
          "Content-Type": "application/json",
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          logUserActivity({ detail: "Call-Back-Requested" });
          setFormSuccessMessage("Request submitted successfully!");
          form.resetFields();
        })
        .catch((error) => {});
    } catch (err) {}
  };

  return (
    <div style={{ background: "#fff" }}>
      <div style={{ maxWidth: 520, margin: "0 auto", padding: "40px 20px 64px" }}>
        {/* Heading + intro */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 700,
              letterSpacing: -0.5,
              margin: 0,
              color: "#1f1f1f",
            }}
          >
            Contact Our Sales Team
          </h1>
          <p
            style={{
              marginTop: 14,
              color: "#595959",
              fontSize: 16,
              lineHeight: 1.7,
            }}
          >
            Leave your details and we'll call you back shortly — or reach us
            directly right now.
          </p>
        </div>

        {/* Direct call action */}
        <a
          href="tel:8000002808"
          onClick={() => logUserActivity({ detail: "Call Us" })}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
            padding: "16px 18px",
            borderRadius: 14,
            border: `1px solid ${ACCENT}`,
            background: "rgba(39,178,196,0.06)",
            marginBottom: 28,
            textDecoration: "none",
          }}
        >
          <span
            style={{
              flexShrink: 0,
              width: 44,
              height: 44,
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: ACCENT,
              color: "#fff",
              fontSize: 18,
            }}
          >
            <PhoneOutlined />
          </span>
          <span style={{ lineHeight: 1.4 }}>
            <span style={{ display: "block", color: "#8c8c8c", fontSize: 13 }}>
              Call us directly
            </span>
            <span
              style={{ display: "block", color: "#1f1f1f", fontSize: 18, fontWeight: 700 }}
            >
              80000 02808
            </span>
          </span>
        </a>

        {/* Divider */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            margin: "0 0 24px",
          }}
        >
          <span style={{ flex: 1, height: 1, background: "#f0f0f0" }} />
          <span style={{ color: "#bfbfbf", fontSize: 13, fontWeight: 500 }}>
            or request a call back
          </span>
          <span style={{ flex: 1, height: 1, background: "#f0f0f0" }} />
        </div>

        {/* Form */}
        <div
          style={{
            padding: "28px 24px",
            borderRadius: 16,
            border: "1px solid #f0f0f0",
            background: "#fff",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Form.Item
              label="Your Name"
              name="name"
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Enter your name" size="large" />
            </Form.Item>

            <Form.Item
              label="Mobile Number"
              name="mobile"
              rules={[
                { required: true, message: "Please enter your mobile number" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Enter a valid 10-digit number",
                },
              ]}
            >
              <Input
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
                size="large"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                icon={<SendOutlined />}
                size="large"
                htmlType="submit"
                block
              >
                Submit Request
              </Button>

              {formSuccessMessage ? (
                <div style={{ marginTop: 16 }}>
                  <Alert message={formSuccessMessage} type="success" showIcon />
                </div>
              ) : null}
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CallBackPage;
